/* eslint-disable consistent-return */
// eslint-disable-next-line import/no-extraneous-dependencies
import { PUBLIC_ENV_KEY } from 'next-runtime-env';

import { BASE_PATH } from '@/constants/base-path';
import { getIsServerSide } from '@/helpers/isServerSide';

const buildEnv = <T extends readonly string[]>(keys: T) =>
  Object.fromEntries(keys.map((key) => [key, process.env[key] ?? null])) as Record<T[number], string>;

const publicEnvKeys = [
  'NODE_ENV',
  'BASE_URL',
  'AUTHENTICATION_BASE_URL',
  'IDENTITY_URL',
  'FONTS_CDN',
  'RECAPCHA_KEY',
  'RECAPTCHA_SCORE_BASED_KEY',
  'RECAPTCHA_SCRIPT_URL',
  'GTM_ID',
  'GTM_ID_2',
  'CLIENT_ID',
  'CLIENT_SECRET',
  'LOG_DIRECTORY',
  'CMS_BASE_URL',
  'USE_OPTIMIZELY',
  'OPTIMIZELY_SDK_KEY',
  'OSANO_CONFIG_ID',
  'APP_NAME',
  'APP_VERSION',
  'RUBY_CHAT_WS_URL',
  'AUTH_IFRAME_URL',
] as const;

const staticEnv = {
  context: process.env.NODE_ENV === 'production' ? BASE_PATH : '',
} as const;

export const publicEnv = Object.assign(buildEnv(publicEnvKeys), staticEnv);

const serverEnvKeys = [
  'cmsRestUsername',
  'cmsRestPassword',
  'REDIS_URL',
  'BASIC_TOKEN',
  'OPTIMIZELY_PROJECT_ID',
  'FFA_BASE_URL',
] as const;

const serverEnv = buildEnv(serverEnvKeys);

export const env = new Proxy(
  {
    ...publicEnv,
    ...serverEnv,
  },
  {
    get(target, key) {
      if (getIsServerSide() || target.NODE_ENV === 'test') {
        return target[key as keyof typeof target];
      }

      const map = window[PUBLIC_ENV_KEY];

      if (!map) {
        return '';
      }

      if (map) return map[key as string];

      // eslint-disable-next-line no-console
      console.error(
        `Unable to find window[${typeof PUBLIC_ENV_KEY === 'string' ? `"${PUBLIC_ENV_KEY}" ${String(key)}` : PUBLIC_ENV_KEY}]`,
      );
    },
  },
);
